<template>

  <div>
      <Banner></Banner>


    <section class="products">
      <div class="container">

        <!--<div class="box-title">
          <h1>Nuevo Pedido</h1>
          <p>Si tenés dudas, por favor escribinos a mayoristas@gorsh.com.</p>
        </div>-->

        <div class="row">

          <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="product in products" :key="product.id" v-if="products.length>0">
            <product-box :product="product"></product-box>
          </div>

          <infinite-loading @infinite="infiniteScrollRest" spinner="waveDots">

            <div slot="no-more"></div>
            <div slot="no-results"><!-- No hay productos disponbibles por el momento, revise más tarde. --></div>

          </infinite-loading>

          <div v-if="products.length<=0">
           <!-- <p>No hay productos destacados</p> -->
          </div>

        </div>
      </div>
    </section>

  </div>

</template>

<script>
import Banner from "@/components/Banner";
import ProductBox from "@/components/ProductBox";
import Api from '@/Api'
export default {
  components: {ProductBox, Banner},
  data () {
    return {
      products:[],
      currentPage:1,
      totalPage:0,
      trigger: 300,
      totalItems:0
    }
  },
  methods:{
    infiniteScrollRest ($state) {


      Api().get('?func=getProductosFromCategory&id=845&page='+this.currentPage).then(data=>{

        if (data.data.success){
          data.data.payload.products.forEach(value => {
            this.products.push(value);
          });

          if (this.currentPage==data.data.payload.total_pages){
            $state.complete();
          }else{
            this.currentPage = data.data.payload.current_page + 1;
            $state.loaded();
          }




        }else{
          this.products = [];
        }

      }).catch(err=>{

      });

    },

  },
  mounted(){
    $('body').removeClass();

    //this.scroll();
    /* Api().get('?func=getProductosFromCategory&id=845').then(data=>{
      if (data.data.success){
        this.products = data.data.payload.products;
        this.currentPage = data.data.payload.current_page;
        this.totalPage = data.data.payload.total_pages;
      }else{
        this.products = [];
      }

    }).catch(err=>{

    }); */

    // Api().get('?func=getProductosByKeyword&keyword=uni').then(data=>{

  }
}
</script>

<!-- Add "thisd" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/HomePage.vue